import React from 'react';
import RHMetricCard from './RHMetricCard';

const fallbackMetrics = [
  { label: 'Solde d’absences', value: '5 jours', detail: 'disponibles' }, { label: 'Prochaine absence', value: '12–16 août 2026' },
  { label: 'Temps hebdomadaire', value: '35 h' }, { label: 'Formation en cours', value: 'Méthodologie DOE', detail: '60 %' },
];
const fallbackActions = ['Compléter le contact d’urgence', 'Signer l’avenant', 'Valider la formation sécurité'];
const fallbackEvents = [{ date: '12 août', label: 'Congés' }, { date: '5 septembre', label: 'Formation DOE' }, { date: '15 septembre', label: 'Entretien annuel' }];
const fallbackDocuments = ['Bulletin de paie — Juin 2026', 'Attestation employeur', 'Contrat de travail'];

function MyRHOverview({ metrics = fallbackMetrics, actions = fallbackActions, events = fallbackEvents, documents = fallbackDocuments, onAction }) {
  return (
    <section className="rh-panel" aria-labelledby="rh-overview-title">
      <div className="rh-panel__header"><div><h2 id="rh-overview-title">Vue d’ensemble</h2><p>Les informations essentielles de votre espace RH.</p></div></div>
      <div className="rh-metric-grid">{metrics.map((metric) => <RHMetricCard key={metric.label} {...metric} />)}</div>
      <div className="rh-overview-grid">
        <article className="rh-content-card"><h3>Mes actions</h3><ul className="rh-action-list">{actions.map((action) => <li key={action.id || action.label || action}>{onAction ? <button type="button" onClick={() => onAction(action)}>{action.label || action}</button> : <span>{action.label || action}</span>}</li>)}</ul></article>
        <article className="rh-content-card"><h3>Prochains événements</h3><ul className="rh-event-list">{events.map((event) => <li key={`${event.date}-${event.label}`}><time>{event.date}</time><span>{event.label}</span></li>)}</ul></article>
        <article className="rh-content-card"><h3>Documents récents</h3><ul className="rh-document-list">{documents.map((document) => <li key={document.id || document.name || document}>{document.name || document}</li>)}</ul></article>
      </div>
    </section>
  );
}

export default MyRHOverview;
